<template>
  <div :class="['wrapper',faculdadename]">  
    <h1>“</h1>
    <p>{{depoimento}}</p>
    <div class="person">
      <img :src="imagem"/>
      <h2>{{nome}} - {{curso}}</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "TestemunhoItem",
  props:["nome","depoimento","curso","imagem","faculdadename"]
}
</script>

<style scoped lang="scss">
@import "../../global.scss";

.wrapper {
  flex: 0 1 calc(50% - 30px);
  margin: 0 15px;
  position: relative;
  flex-direction: column;
  background-color: white;
  margin-bottom: 12px;
  border-radius: 7px;
  padding: 60px 40px 28px 50px;
  box-shadow: 2px 4px 17px -8px #928888ba;
  display: grid;
  grid-template-rows: 1fr auto;
  gap: 10px;
}

.wrapper:hover {
  cursor: pointer;
}

@media screen and (max-width: 1024px) {
  .wrapper{
    flex: 0 1 100%;
  }
}

.wrapper.artes-e-humanidades{
  color: $ahc2;
}
.wrapper.ciencias-exatas-e-da-engenharia{
  color: $ceec2;
}
.wrapper.ciencias-sociais{
  color: $ccc2;
}
.wrapper.ciencias-da-vida{
  color: $cvc2;
}
.wrapper.escola-superior-de-saude{
  color: $essc2;
}
.wrapper.escola-superior-de-tecnologias-e-gestao,
.wrapper.escola-superior-de-tecnologia-e-gestao{
  color: $estgc2;
}
/*
.wrapper.artes-e-humanidades {
  color: $artesHumanidades;
}
.wrapper.ciencias-exatas-e-da-engenharia {
  color: $cee;
}
.wrapper.ciencias-sociais {
  color: $cs;
}
.wrapper.ciencias-da-vida {
  color: $cv;
}
.wrapper.escola-superior-de-saude {
  color: $ess;
}
.wrapper.escola-superior-de-tecnologia-e-gestao {
  color: $estg;
}*/


img {
  display: block;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background: #b1b1b1 center;
  margin-right: 2.65%;
}

h1 {
  font-family: 'Montserrat Light',serif;
  font-size: 140px;
  position: absolute;
  line-height: 1;
  top: 0;
  left: 50px;
}

p {
  font-family: Montserrat,serif;
  font-size: 15px;
  color: #454648;
  padding-bottom: 0;
}

h2 {
  font-family: "Montserrat Semibold",serif;
  font-size: 16px;
  margin-bottom: 0;
  letter-spacing: normal;
}

.person {
  display:flex;
  align-items: center;
  grid-row-start: 2; /* Ensures .person is placed in the second row */
}


@media (max-width: 1440px) {
  h2 {
    font-size: 15px;
  }
}

@media (max-width: 1220px) {
  p {
    line-height: 1.5;
    margin-bottom: 2px;
  }

  h2 {
    line-height: 1.2;
  }

  h1 {
    font-size: 100px;
    top:10px;
  }

  .wrapper{
    padding-top: 53px;
  }

}

/*Responsive - ipad*/
@media (max-width: 1023px) {
  .wrapper{
    padding-right: 15px;
  }

  h2 {
    padding-top: 0;
    font-size: 14px;
    margin-bottom: 0;
  }

  img {
    width: 33px;
    height: 33px;
  }

  p {
    margin-right: 20px;
    margin-left: 0;
    padding-left: 0;
  }
}

/*Responsive - iphone*/
@media (max-width: 767px) {

  .person{
    padding-top: 5px;
  }

  p {
    padding-right: 15px;
    font-size: 13px;
    height: auto;
    margin-bottom: 0;
  }

  h1 {
    font-size: 90px;
    left: 30px;
  }

  h2 {
    font-size: 13px;
    line-height: 15px;
  }

  .wrapper {
    padding: 40px 10px 25px 35px;
  }

  .wrapper p {
    margin-top: 10px;
    margin-bottom: 15px;
    margin-right: 0px;
  }
}
</style>